import { enUS, es } from 'date-fns/locale';
import { format, parse } from 'date-fns';
export const timeToExpire = (expiryTime) => {
    const timeLeftMs = expiryTime.getTime() - Date.now();
    return Math.floor(timeLeftMs / 1000);
};
export const checkExpiration = (expiryTime, durationSeconds, expiringSoon, setExpiringSoon) => {
    if (timeToExpire(expiryTime) < durationSeconds && !expiringSoon) {
        setExpiringSoon(true);
    }
};
export const getExpiredDate = (expiryTime) => new Date(Date.now() + expiryTime * 1000);
const capitalizeFirstLetter = (value) => {
    return value.charAt(0).toUpperCase() + value.slice(1);
};
const formatDateStringToObject = (dateString) => {
    return parse(dateString === null || dateString === void 0 ? void 0 : dateString.substring(0, 10), 'yyyy-MM-dd', new Date());
};
export const formatDisplayDateWithFormat = (date, formatString, language = 'en') => {
    const localeLang = language === 'es' ? es : enUS;
    if (typeof date === 'string') {
        return capitalizeFirstLetter(format(formatDateStringToObject(date), formatString, {
            locale: localeLang
        }));
    }
    return capitalizeFirstLetter(format(date, formatString, { locale: localeLang }));
};
//# sourceMappingURL=helpers.js.map